import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import {
  aiParametersAvg,
  capitalizeFirstLetter,
  formatSummaryTitle,
  scoreAvg,
} from "../../../utils/Common/Constant";
import CircularProgressBar from "./CircularReportBar";
import React from "react";
Font.register({
  family: "Montserrat",
  fonts: [
    {
      src: `${window.location.origin}/fonts/Montserrat-Regular.ttf`,
    },
    {
      src: `${window.location.origin}/fonts/Montserrat-Bold.ttf`,
      fontWeight: "bold",
    },
    {
      src: `${window.location.origin}/fonts/Montserrat-Medium.ttf`,
      fontWeight: "medium",
    },
  ],
});
const styles = StyleSheet.create({
  page: {
    padding: 30,
    backgroundColor: "#ffffff",
    fontFamily: "Montserrat",
  },
  logoHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 30,
  },
  evluatelogo: {
    width: 80,
    height: 20,
  },
  header: {
    marginBottom: 30,
  },
  logo: {
    width: 100,
    marginBottom: 20,
  },
  title: {
    fontSize: 22,
    textAlign: "center",
    marginBottom: 20,
    color: "#000000",
    fontWeight: "bold",
  },
  profileSection: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 30,
    justifyContent: "space-between",
  },
  avatarDiv: {
    width: 60,
    height: 60,
    borderRadius: 30,
    marginRight: 15,
    backgroundColor: "#ffffff",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 0.8,
    borderColor: "#e0e0e0",
    padding: 2,
  },
  avatar: {
    width: 50,
    height: 50,
    borderRadius: 25,
    objectFit: "cover",
  },
  userInfo: {
    marginRight: 20,
  },
  icon: {
    width: 6,
    height: 6,
  },
  userName: {
    fontSize: 18,
    marginBottom: 1,
    color: "#35D4AE",
    fontWeight: "bold",
  },
  emailPhoneSec: {
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
  },
  userContact: {
    fontSize: 10,
    color: "#2D2D2D",
    marginBottom: 1,
  },
  scoreOverview: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 5,
    backgroundColor: "#ffffffff",
    borderColor: "#35D4AE",
    borderWidth: 2,
    borderRadius: 50,
  },
  scoreBox: {
    padding: 10,
    borderRadius: 5,
    width: 100,
    alignItems: "center",
  },
  rightBox: {
    borderRightWidth: 0.5,
    borderRightColor: "#c5c5c5",
    borderRadius: "0",
  },
  scoreLabel: {
    fontSize: 10,
    marginBottom: 5,
    color: "#4D4D4D",
    fontWeight: "medium",
  },
  scoreValue: {
    fontSize: 20,
    color: "#000000ff",
    fontWeight: "bold",
  },
  section: {
    marginTop: 20,
    marginBottom: 5,
  },
  naText: {
    fontSize: 12,
    color: "#666666",
    fontWeight: "medium",
  },
  sectionTitleWrapper: {
    flexDirection: "row",
  },
  sectionTitle: {
    fontSize: 12,
    marginBottom: 10,
    color: "#2d2d2d",
    fontWeight: "medium",
  },
  ratingSec: {
    flexDirection: "row",
    gap: 5,
    alignItems: "center",
    marginRight: 25,
    marginBottom: 5,
  },
  skillRating: {
    fontSize: 10,
    color: "#2d2d2d",
  },
  experienceScore: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#2d2d2d",
  },
  barContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
    marginBottom: 10,
  },
  barLabel: {
    fontSize: 10,
    color: "#2D2D2D",
    fontWeight: "medium",
  },
  bar: {
    flex: 1,
    height: 12,
    backgroundColor: "#E8E8E8",
    borderRadius: 1,
  },
  barFill: {
    height: "100%",
    backgroundColor: "#35D4AE",
    borderRadius: 1,
  },
  barValue: {
    width: 35,
    fontSize: 10,
    textAlign: "right",
    marginLeft: 5,
    fontWeight: "medium",
  },
  analysisSection: {
    marginTop: 15,
    padding: 15,
    backgroundColor: "#f8f8f8",
  },
  Viewider: {
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
    marginVertical: 15,
  },
  categorySummary: {
    marginTop: 10,
    padding: 10,
    backgroundColor: "#f8f8f8",
    borderRadius: 4,
  },
  skillNameSection: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  namePercentRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  skillName: {
    fontSize: 12,
    color: "#333",
  },
  percentValue: {
    fontSize: 12,
    color: "#008000",
  },
  summarySection: {
    marginTop: 10,
    backgroundColor: "#F4FFFC",
    padding: 12,
    marginBottom: 12,
    borderRadius: 3,
  },
  categorySkillsSec: {
    borderWidth: 1,
    borderColor: "#8effe4",
    backgroundColor: "#ffffff",
    borderRadius: 3,
    padding: 8,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
    marginBottom: 20,
    width: "100%",
  },
  skillNamePercentageSec: {
    width: "45%",
    marginBottom: 10,
  },
  namePercent: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    minHeight: "auto",
  },
  name: {
    width: "70%",
    fontWeight: "medium",
    fontSize: 8,
    color: "#2D2D2D",
  },
  percent: {
    width: "25%",
    fontWeight: "bold",
    fontSize: 8,
    color: "#2D2D2D",
    textAlign: "right",
  },
  barLine: {
    marginTop: 5,
    height: 2,
    width: "100%",
  },
  summaryEntry: {
    flexDirection: "row",
    alignItems: "baseline",
    marginBottom: 8,
    gap: 8,
    flexWrap: "wrap",
  },
  bullet: {
    width: 5,
    height: 5,
    backgroundColor: "#35D4AE",
    borderRadius: 2.5,
    marginTop: 5,
  },
  keyValuePair: {
    flex: 1,
    flexDirection: "column",
    gap: 2,
  },
  keyText: {
    fontSize: 10,
    color: "#2D2D2D",
    marginBottom: 2,
    fontWeight: "bold",
  },
  valueText: {
    fontSize: 10,
    color: "#2D2D2D",
  },
  finalRecommendationSec: {
    padding: 20,
    marginTop: 15,
    backgroundColor: "#2D2D2D",
  },
  finalRecomTitle: {
    fontWeight: "bold",
    fontSize: 16,
    color: "#ffffff",
  },
  feedbackContentFirst: {
    borderRight: "1px solid #c5c5c5",
    paddingRight: 30,
  },
  positive: {
    fontSize: 12,
    fontWeight: "bold",
    textDecoration: "underline",
    marginTop: 5,
    marginBottom: 5,
    paddingBottom: 10,
    color: "#35D4AE",
  },
  improvement: {
    fontSize: 12,
    fontWeight: "bold",
    textDecoration: "underline",
    marginTop: 5,
    marginBottom: 5,
    paddingBottom: 10,
    color: "#ea4435",
  },
  recommendationPoints: {
    flexDirection: "row",
    gap: 30,
    flexWrap: "wrap",
    marginTop: 5,
    width: "100%",
  },
  feedbackContent: {
    flex: 1,
    color: "#ffffff",
  },
  recommendationText: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 8,
    marginBottom: 8,
  },
  dot: {
    width: 3,
    height: 3,
    borderRadius: 1.5,
    backgroundColor: "#f5f5f5ff",
    flexShrink: 0,
    marginTop: 5,
  },
  text: {
    fontSize: 10,
    marginBottom: 3,
  },
  dividerLine: {
    width: "100%",
    height: 0.5,
    backgroundColor: "#c5c5c5",
  },
  detailContainer: {
    marginTop: 10,
    flexDirection: "row",
    gap: 10,
  },
  detailColumn: {
    flex: 1,
  },
  detailLabel: {
    fontSize: 10,
    color: "#2D2D2D",
    marginBottom: 10,
    fontWeight: "medium",
  },
  detailValue: {
    fontSize: 10,
    color: "#2D2D2D",
    marginBottom: 10,
    fontWeight: "medium",
  },
  skillsWrapper: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 5,
    marginVertical: 0,
    alignItems: "center",
  },
  skillBullet: {
    paddingHorizontal: 5,
    paddingVertical: 3,
    borderRadius: 2,
    fontSize: 8,
    color: "#fff",
    textAlign: "center",
    backgroundColor: "#35D4AE",
    fontWeight: "medium",
  },
  remarkBullet: {
    padding: 3,
    fontSize: 8,
    color: "#fff",
    alignSelf: "flex-start",
    borderRadius: 2,
    fontWeight: "medium",
  },
  scoreHeaderValue: {
    fontSize: 14,
    color: "#35D4AE",
    fontWeight: "bold",
    marginLeft: 5,
  },
  headerDivider: {
    flex: 1,
    height: 0.5,
    backgroundColor: "#c5c5c5",
    marginTop: 10,
    marginBottom: 20,
    marginLeft: 5,
  },
  // My css
  scoreTitle: {
    fontSize: 14,
    color: "#2D2D2D",
    fontWeight: "bold",
    textAlign: "center",
    paddingLeft: 5,
  },
  width30: {
    width: "40%",
  },
  width70: {
    width: "60%",
  },
  borderOrange: {
    borderColor: "#FA8054",
    backgroundColor: "#FFFCF8",
  },
  borderPurple: {
    borderColor: "#AA60EB",
    backgroundColor: "#FCF6FF",
  },
  borderGreen: {
    borderColor: "#35EB2B",
    backgroundColor: "#F6FFF6",
  },
  borderCyan: {
    borderColor: "#35D4AE",
    backgroundColor: "#FAFFFE",
  },
  bulletOrange: {
    backgroundColor: "#FA8054",
  },
  bulletPurple: {
    backgroundColor: "#AA60EB",
  },
  bulletGreen: {
    backgroundColor: "#35EB2B",
  },
  bulletCyan: {
    backgroundColor: "#35D4AE",
  },

  rightArrow: {
    width: 10,
    height: 10,
    borderBottom: 10,
    borderTop: 7.5,
    borderLeft: 15,
    borderStyle: "solid",
    borderRight: 10,
    borderBottomColor: "transparent",
    borderTopColor: "transparent",
    borderLeftColor: "#f97352",
    borderRightColor: "transparent",
    padding: 5,
  },
  flexProperty: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  outOfScore: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#2d2d2d",
    borderWidth: 1,
    borderRadius: 50,
    padding: 6,
  },
  mbBottom: {
    marginBottom: 20,
    padding: 20,
  },
  circularBar: {
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    borderWidth: 3,
    borderStyle: "dotted",
    padding: 5,
  },
});
const borderColors = [
  styles.borderOrange,
  styles.borderPurple,
  styles.borderGreen,
  styles.borderCyan,
];
const bulletsColors = [
  styles.bulletOrange,
  styles.bulletPurple,
  styles.bulletGreen,
  styles.bulletCyan,
];

const ProgressBar = ({
  value,
  label,
  style,
  hideValue = false,
  barColor = "#35D4AE",
}: {
  value?: number | undefined;
  label?: string;
  style?: any;
  hideValue?: boolean;
  barColor?: any;
}) => {
  const safeValue =
    typeof value === "number" ? Math.min(Math.max(value, 0), 100) : 0;

  return (
    <View style={styles.barContainer}>
      <Text style={styles.barLabel}>{label}</Text>
      <View
        style={{ width: "100%", flexDirection: "row", alignItems: "center" }}
      >
        <View style={[styles.bar, style]}>
          <View
            style={[
              styles.barFill,
              { width: `${safeValue}%`, backgroundColor: barColor },
            ]}
          />
        </View>
        {!hideValue && <Text style={styles.barValue}>{safeValue}%</Text>}
      </View>
    </View>
  );
};

const AssessmentReport = ({ reportData }: any) => {
  const { t } = useTranslation();
  const positiveFeedbackArray = Object.values(
    reportData?.finalRecommendation ?? {},
  ).map((item: any) => item?.positive_feedback);
  const areaOfImprovementArray = Object.values(
    reportData?.finalRecommendation ?? {},
  ).map((item: any) => item?.area_of_improvement);
  const getRemarkClass = (remark?: string) => {
    switch (remark) {
      case "Below Par":
        return "#da5d5d";
      case "Good":
        return "#dbb52f";
      case "Satisfactory":
        return "#ff8635";
      case "Excellent":
        return "#2ebec6";
      default:
        return "";
    }
  };
  const emotionOrder = [
    "Calm",
    "Happy",
    "Sad",
    "Angry",
    "Confused",
    "Disgusted",
    "Fear",
    "Surprised",
  ];
  const filterSkillsForCategory = (
    categoryScore: any[],
    assessmentSkills: any[],
    skillScore: any[],
  ) => {
    return categoryScore.map((category) => {
      const skillsInCategory = assessmentSkills.filter(
        (skill) => skill.categoryId === category.skillsCategoryId,
      );

      const seen = new Set<string>();

      const skills = skillsInCategory
        .map((skill) => {
          const matchingScore = skillScore.find(
            (s) => s.key === skill.skillName,
          );
          if (matchingScore && !seen.has(skill.skillName)) {
            seen.add(skill.skillName);
            return {
              skillName: skill.skillName,
              score: matchingScore.score,
            };
          }
          return null;
        })
        .filter(Boolean);
      return {
        ...category,
        skills,
      };
    });
  };
  const itemsPerPage = 2;
  return (
    <Document title={reportData?.applicantDetails?.displayName}>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.logoHeader}>
          <Image src="/Images/evluateLogo.png" style={styles.evluatelogo} />
          <View style={[styles.headerDivider, { marginTop: 20 }]} />
        </View>
        <View style={styles.header}>
          <Text style={styles.title}>
            {reportData?.applicantDetails?.title}
          </Text>
        </View>

        {/* Profile Section */}
        <View style={styles.profileSection}>
          <View style={{ flexDirection: "row", alignItems: "center", gap: 5 }}>
            <div style={styles.avatarDiv}>
              <Image
                style={styles.avatar}
                src={reportData?.applicantDetails?.applicantImage}
              />
            </div>
            <View style={styles.userInfo}>
              <Text style={styles.userName}>
                {reportData?.applicantDetails?.displayName}
              </Text>
              <View style={styles.emailPhoneSec}>
                <Image style={styles.icon} src="/Images/Email.png" />

                <Text style={styles.userContact}>
                  {reportData?.applicantDetails?.email}
                </Text>
              </View>
              <View style={styles.emailPhoneSec}>
                <Image style={styles.icon} src="/Images/mobile.png" />
                <Text style={styles.userContact}>
                  {reportData?.applicantDetails?.mobile ?? "-"}
                </Text>
              </View>
            </View>
          </View>
          <View style={styles.scoreOverview}>
            <View style={[styles.scoreBox, styles.rightBox]}>
              <Text style={styles.scoreLabel}>{t("GENERAL.CUTOFF")}</Text>
              <Text style={styles.scoreValue}>
                {reportData?.applicantDetails?.cutOff}%
              </Text>
            </View>
            <View style={styles.scoreBox}>
              <Text style={styles.scoreLabel}>
                {t("RESPONSE_LIST.OVERALL_SCORE")}
              </Text>
              <Text style={styles.scoreValue}>
                {reportData?.applicantDetails?.finalScore?.score}%
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.dividerLine} />
        {/* Self Rating */}
        <View
          style={[
            styles.section,
            {
              backgroundColor: "#F5FFFD",
              padding: 10,
            },
          ]}
        >
          <Text style={styles.sectionTitle}>
            {t("RESPONSE_LIST.APPLICANTS_SELF_RATING")}
          </Text>
          <View style={styles.skillNameSection}>
            {reportData?.applicantSkillExperience?.map(
              (skill: any, index: number) => (
                <View key={index} style={styles.ratingSec}>
                  <Text style={styles.skillRating}>
                    {skill.skill.skillName}
                  </Text>
                  <Text style={styles.experienceScore}>{skill.experience}</Text>
                </View>
              ),
            )}
          </View>
          {/* comments */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{t("GENERAL.COMMENT")}</Text>
            <Text style={styles.valueText}>
              {reportData?.applicantDetails?.finalComment ?? "-"}
            </Text>
          </View>
          {/* Assessment details */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>
              {t("GENERAL.ASSESSMET_DETAILS")}
            </Text>
            <View style={styles.detailContainer}>
              <View style={[styles.detailColumn, { flex: 2 }]}>
                <Text style={styles.detailLabel}>
                  {t("RESUME.ASSESSMENT_QUESTIONS")}
                </Text>
                <Text style={styles.detailLabel}>{t("GENERAL.TIME")}</Text>
                <Text style={styles.detailLabel}>{t("GENERAL.REMARK")}</Text>
              </View>
              <View style={[styles.detailColumn, { flex: 5 }]}>
                <Text style={styles.detailValue}>
                  {reportData?.applicantDetails?.totalQuestions}
                </Text>
                <Text style={styles.detailValue}>
                  {reportData?.applicantDetails?.totalTime} {t("GENERAL.MINS")}
                </Text>
                <Text
                  style={[
                    styles.remarkBullet,
                    {
                      backgroundColor: getRemarkClass(
                        reportData?.applicantDetails?.remark,
                      ),
                    },
                  ]}
                >
                  {reportData?.applicantDetails?.remark ?? "-"}
                </Text>
              </View>
              <View style={[styles.detailColumn, { flex: 3 }]}>
                <Text style={styles.detailLabel}>{t("GENERAL.CUTOFF")}</Text>
                <Text style={styles.detailLabel}>
                  {t("GENERAL.RESULT_STATUS")}
                </Text>
              </View>
              <View style={[styles.detailColumn, { flex: 2 }]}>
                <Text style={styles.detailValue}>
                  {reportData?.applicantDetails?.cutOff != null
                    ? `${reportData?.applicantDetails.cutOff}%`
                    : "-"}
                </Text>
                <Text style={styles.detailValue}>
                  {reportData?.applicantDetails?.resultStatus ?? "-"}
                </Text>
              </View>
            </View>
          </View>
          {/* skills bullets */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{t("GENERAL.SKILLS")}</Text>
            <View style={styles.skillsWrapper}>
              {reportData?.assessmentSkills?.map((item: any, index: any) => (
                <Text key={index} style={styles.skillBullet}>
                  {item?.skillName} - {item?.questionType}
                </Text>
              ))}
            </View>
          </View>
        </View>

        {/* Overall Score */}
        <View style={styles.section} break>
          <View style={styles.sectionTitleWrapper}>
            <View style={styles.headerDivider} />
            <Text style={styles.scoreTitle}>
              {t("RESPONSE_LIST.OVERALL_SCORE")}
            </Text>
            <Text style={styles.scoreHeaderValue}>
              {reportData?.applicantDetails?.finalScore?.score}%
            </Text>
            <View style={styles.headerDivider} />
          </View>
        </View>

        {/* Culture Fit */}
        <View style={styles.section}>
          {filterSkillsForCategory(
            reportData?.categoryScore,
            reportData?.assessmentSkills,
            reportData?.skillScore,
          )?.map((category: any, index: number) => {
            const randomIndex = Math.floor(Math.random() * borderColors.length);
            const randomStyle = borderColors[randomIndex]; // border color
            const bulletStyle = bulletsColors[randomIndex]; // matching bullet color
            const barColor = randomStyle.borderColor;

            return (
              <React.Fragment key={index}>
                <View style={[styles.mbBottom, randomStyle]}>
                  <View style={styles.flexProperty}>
                    <Text style={styles.sectionTitle}>
                      {category.categoryName}
                    </Text>
                    <Text style={[styles.outOfScore, randomStyle]}>
                      {category?.totalScore} / 100
                    </Text>
                  </View>

                  <View
                    style={[
                      styles.section,
                      {
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: 10,
                      },
                    ]}
                  >
                    <View style={[styles.sectionTitle, styles.width30]}>
                      {category?.skills?.map((skill: any, i: number) => (
                        <View
                          key={i}
                          style={[styles.categorySkillsSec, randomStyle]}
                        >
                          <View
                            style={[
                              styles.skillNamePercentageSec,
                              { width: "100%" },
                            ]}
                          >
                            <View
                              style={[styles.namePercent, { width: "100%" }]}
                            >
                              <Text style={styles.name}>{skill.skillName}</Text>
                              <Text style={styles.percent}>{skill.score}%</Text>
                            </View>

                            <View style={[styles.barLine, randomStyle]}>
                              <ProgressBar
                                style={[styles.barLine]}
                                value={skill.score}
                                hideValue={true}
                                barColor={barColor}
                              />
                            </View>
                          </View>
                        </View>
                      ))}
                    </View>

                    <View style={[styles.sectionTitle, styles.width70]}>
                      {Object.entries(category?.summary || {}).map(
                        ([key, value], subIndex) => (
                          <View key={subIndex} style={styles.summaryEntry}>
                            <View style={[styles.bullet, bulletStyle]} />
                            <View style={styles.keyValuePair}>
                              <Text style={styles.keyText}>
                                {formatSummaryTitle(key)}:
                              </Text>
                              <Text style={styles.valueText}>
                                {value ? String(value) : "-"}
                              </Text>
                            </View>
                          </View>
                        ),
                      )}
                    </View>
                  </View>
                </View>
                {(index + 1) % itemsPerPage === 0 && <View break />}
              </React.Fragment>
            );
          })}
        </View>

        {/* Difficulty Level Analysis */}
        <View style={styles.section} break>
          {(() => {
            const randomStyle =
              borderColors[Math.floor(Math.random() * borderColors.length)];
            const barColor = randomStyle.borderColor;
            return (
              <View
                style={[
                  styles.mbBottom,
                  randomStyle,
                  { borderWidth: 1, borderColor: barColor, borderRadius: 3 },
                ]}
              >
                <View style={styles.flexProperty}>
                  <Text style={styles.sectionTitle}>
                    {t("GENERAL.DIFFICULTY_WISE_ANALYSIS")}
                  </Text>
                  <Text style={[styles.outOfScore, randomStyle]}>
                    {scoreAvg(reportData?.skillScore)} / 100
                  </Text>
                </View>
                <View
                  style={[
                    styles.dividerLine,
                    { marginTop: 10, marginBottom: 10 },
                  ]}
                />
                <View
                  style={[
                    styles.flexProperty,
                    { gap: 10, flexWrap: "wrap", justifyContent: "flex-start" },
                  ]}
                >
                  {reportData?.skillDIfficultyScore?.map(
                    (level: any, index: number) => (
                      <View
                        key={index}
                        style={{ marginBottom: 5, width: "30%", gap: 5 }}
                      >
                        <View
                          style={[
                            styles.flexProperty,
                            { justifyContent: "flex-start", gap: 15 },
                          ]}
                        >
                          <Text style={styles.sectionTitle}>
                            {level.difficultyLevel}
                          </Text>
                          <CircularProgressBar
                            size={70}
                            percent={level.totalscore}
                            color={barColor}
                          />
                        </View>
                      </View>
                    ),
                  )}
                </View>
              </View>
            );
          })()}
        </View>

        {/* AI Analysis */}
        <View style={styles.section}>
          {(() => {
            const randomStyle =
              borderColors[Math.floor(Math.random() * borderColors.length)];
            const barColor = randomStyle.borderColor;
            return (
              <View
                style={[
                  styles.mbBottom,
                  randomStyle,
                  { borderWidth: 1, borderColor: barColor, borderRadius: 3 },
                ]}
              >
                <View style={styles.flexProperty}>
                  <Text style={styles.sectionTitle}>
                    {t("RESPONSE_LIST.AI_ANALYSIS")}
                  </Text>
                  <Text style={[styles.outOfScore, randomStyle]}>
                    {aiParametersAvg(
                      reportData?.applicantDetails?.evaluationSummary
                        ?.aiAnalysis ?? {},
                    )}{" "}
                    / 100
                  </Text>
                </View>
                <View
                  style={[
                    styles.dividerLine,
                    { marginTop: 10, marginBottom: 10 },
                  ]}
                />
                <View
                  style={[
                    styles.flexProperty,
                    { justifyContent: "flex-start", gap: 10, flexWrap: "wrap" },
                  ]}
                >
                  {reportData?.applicantDetails?.evaluationSummary
                    ?.aiAnalysis ? (
                    Object.entries(
                      reportData?.applicantDetails?.evaluationSummary
                        ?.aiAnalysis || {},
                    )
                      .map(
                        ([key, value]) =>
                          [key === "accuracy" ? "correctness" : key, value] as [
                            string,
                            number | null,
                          ],
                      )
                      .filter(
                        ([key]) =>
                          key !== "language_and_grammar" &&
                          key !== "aiConfidence",
                      )
                      .sort(([keyA], [keyB]) => {
                        const order = [
                          "correctness",
                          "completeness",
                          "clarity",
                          "relevance",
                          "depth",
                          "positivity",
                        ];
                        const indexA = order.indexOf(keyA);
                        const indexB = order.indexOf(keyB);
                        if (indexA === -1 && indexB === -1) return 0;
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                      })
                      .map(([emotion, value]: [string, any], index: number) => (
                        <View
                          key={index}
                          style={
                            (styles.skillNamePercentageSec,
                            { width: "30%", marginBottom: 20 })
                          }
                        >
                          <View style={styles.namePercent}>
                            <Text style={styles.name}>
                              {capitalizeFirstLetter(emotion)}
                            </Text>
                            <Text style={styles.percent}>{value}%</Text>
                          </View>
                          <View style={styles.barLine}>
                            <ProgressBar
                              style={styles.barLine}
                              value={value}
                              hideValue={true}
                              barColor={barColor}
                            />
                          </View>
                        </View>
                      ))
                  ) : (
                    <Text style={styles.naText}>{t("GENERAL.NA")}</Text>
                  )}
                </View>
              </View>
            );
          })()}
        </View>

        {/* Visual Analysis */}
        <View style={styles.section}>
          {(() => {
            const randomStyle =
              borderColors[Math.floor(Math.random() * borderColors.length)];
            const barColor = randomStyle.borderColor;
            return (
              <View
                style={[
                  styles.mbBottom,
                  randomStyle,
                  { borderWidth: 1, borderColor: barColor, borderRadius: 3 },
                ]}
              >
                <View style={styles.flexProperty}>
                  <Text style={styles.sectionTitle}>
                    {t("RESPONSE_LIST.VISUAL_ANALYSIS")}
                  </Text>
                  <Text style={[styles.outOfScore, randomStyle]}>
                    {aiParametersAvg(
                      reportData?.applicantDetails?.evaluationSummary
                        ?.visualAnalysis ?? {},
                    )}{" "}
                    / 100
                  </Text>
                </View>
                <View
                  style={[
                    styles.dividerLine,
                    { marginTop: 10, marginBottom: 10 },
                  ]}
                />

                <View
                  style={[
                    styles.flexProperty,
                    { justifyContent: "flex-start", gap: 10, flexWrap: "wrap" },
                  ]}
                >
                  {reportData?.applicantDetails?.evaluationSummary
                    ?.visualAnalysis ? (
                    Object.entries(
                      reportData?.applicantDetails?.evaluationSummary
                        ?.visualAnalysis || {},
                    )
                      .filter(
                        ([, value]) => value !== null && value !== undefined,
                      )
                      .sort(
                        ([a], [b]) =>
                          emotionOrder.indexOf(a) - emotionOrder.indexOf(b),
                      )
                      ?.map(
                        ([emotion, value]: [string, any], index: number) => (
                          <View
                            key={index}
                            style={
                              (styles.skillNamePercentageSec,
                              { width: "30%", marginBottom: 20 })
                            }
                          >
                            <View style={styles.namePercent}>
                              <Text style={styles.name}>
                                {capitalizeFirstLetter(emotion)}
                              </Text>
                              <Text style={styles.percent}>{value}%</Text>
                            </View>
                            <View style={styles.barLine}>
                              <ProgressBar
                                style={styles.barLine}
                                value={value}
                                hideValue={true}
                                barColor={barColor}
                              />
                            </View>
                          </View>
                        ),
                      )
                  ) : (
                    <Text style={styles.naText}>{t("GENERAL.NA")}</Text>
                  )}
                </View>
              </View>
            );
          })()}
        </View>

        <View style={styles.flexProperty} break>
          {/* Voice Analysis */}
          {(() => {
            const randomStyle =
              borderColors[Math.floor(Math.random() * borderColors.length)];
            const barColor = randomStyle.borderColor;
            return (
              <View
                style={[
                  styles.mbBottom,
                  randomStyle,
                  {
                    width: "45%",
                    borderWidth: 1,
                    borderColor: barColor,
                    borderRadius: 3,
                  },
                ]}
              >
                <View style={styles.flexProperty}>
                  <Text style={styles.sectionTitle}>
                    {t("CREATE_ASSESSMENT.LABEL_VOICE_ANALYSIS")}
                  </Text>
                  <Text style={[styles.outOfScore, randomStyle]}>
                    {reportData?.applicantDetails?.evaluationSummary
                      ?.voiceAnalysis != null
                      ? `${reportData.applicantDetails.evaluationSummary.voiceAnalysis} / 100`
                      : "0 / 100"}
                  </Text>
                </View>
                <View
                  style={[
                    styles.dividerLine,
                    { marginTop: 10, marginBottom: 10 },
                  ]}
                />
                {reportData?.applicantDetails?.evaluationSummary
                  ?.voiceAnalysis ? (
                  <View style={[styles.flexProperty]}>
                    <Text style={styles.sectionTitle}>
                      {t("CREATE_ASSESSMENT.LABEL_VOICE_ANALYSIS")}
                    </Text>
                    <CircularProgressBar
                      size={70}
                      percent={
                        reportData?.applicantDetails?.evaluationSummary
                          ?.voiceAnalysis
                      }
                      color={barColor}
                    />
                  </View>
                ) : (
                  <Text style={styles.naText}>{t("GENERAL.NA")}</Text>
                )}
              </View>
            );
          })()}
          {/* Communication */}
          {(() => {
            const randomStyle =
              borderColors[Math.floor(Math.random() * borderColors.length)];
            const barColor = randomStyle.borderColor;
            return (
              <View
                style={[
                  styles.mbBottom,
                  randomStyle,
                  {
                    width: "45%",
                    borderWidth: 1,
                    borderColor: barColor,
                    borderRadius: 3,
                  },
                ]}
              >
                <View style={styles.flexProperty}>
                  <Text style={styles.sectionTitle}>
                    {t("RESPONSE_LIST.COMMUNICATION")}
                  </Text>
                  <Text style={[styles.outOfScore, randomStyle]}>
                    {reportData?.applicantDetails?.evaluationSummary?.aiAnalysis
                      ?.language_and_grammar != null
                      ? `${reportData.applicantDetails.evaluationSummary.aiAnalysis.language_and_grammar} / 100`
                      : "0 / 100"}
                  </Text>
                </View>
                <View
                  style={[
                    styles.dividerLine,
                    { marginTop: 10, marginBottom: 10 },
                  ]}
                />
                {reportData?.applicantDetails?.evaluationSummary
                  ?.voiceAnalysis ? (
                  <View style={[styles.flexProperty]}>
                    <Text style={styles.sectionTitle}>
                      {t("RESPONSE_LIST.COMMUNICATION")}
                    </Text>
                    <CircularProgressBar
                      size={70}
                      percent={
                        reportData?.applicantDetails?.evaluationSummary
                          ?.aiAnalysis?.language_and_grammar
                      }
                      color={barColor}
                    />
                  </View>
                ) : (
                  <Text style={styles.naText}>{t("GENERAL.NA")}</Text>
                )}
              </View>
            );
          })()}
        </View>
        {/* Final recoomendaton */}
        {reportData?.finalRecommendation && (
          <View style={styles.finalRecommendationSec}>
            <Text style={styles.finalRecomTitle}>
              {t("GENERAL.FINAL_RECOMMENDATION")}
            </Text>

            <View style={styles.recommendationPoints}>
              {/* Positive Feedback */}
              <View
                style={[styles.feedbackContent, styles.feedbackContentFirst]}
              >
                <Text style={styles.positive}>
                  {t("GENERAL.POSITIVE_FEEDBACK")}
                </Text>
                {positiveFeedbackArray.map((item, index) => (
                  <View key={index} style={styles.recommendationText}>
                    {item && (
                      <>
                        <View style={styles.dot} />
                        <Text style={styles.text}>{item}</Text>
                      </>
                    )}
                  </View>
                ))}
              </View>

              {/* Area of Improvement */}
              <View style={styles.feedbackContent}>
                <Text style={styles.improvement}>
                  {t("GENERAL.AREA_OF_IMPROVEMENT")}
                </Text>
                {areaOfImprovementArray.map((item, index) => (
                  <View key={index} style={styles.recommendationText}>
                    {item && (
                      <>
                        {" "}
                        <View style={styles.dot} />
                        <Text style={styles.text}>{item}</Text>
                      </>
                    )}
                  </View>
                ))}
              </View>
            </View>
          </View>
        )}
      </Page>
    </Document>
  );
};

export default AssessmentReport;
